/**
 * Simple extension of semantic Form to add a little more functionality
 */
import React from 'react'
import PropTypes from 'prop-types'
import { Form as SemanticForm } from '@adc/ui-core'
import classnames from 'classnames/bind'
import FormHeader from './formHeader'
import FormContent from './formContent'
import FormColumn from './formColumn'
import FormSection from './formSection'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const Form = props => {
  const { children, className, padded = true, ...rest } = props
  const newClassName = cx('form', { padded }, className)
  return (
    <SemanticForm {...rest} className={newClassName}>
      {children}
    </SemanticForm>
  )
}

Form.propTypes = {
  ...SemanticForm.propTypes,
  padded: PropTypes.bool,
}

// statics
Form.Header = FormHeader
Form.Content = FormContent
Form.Column = FormColumn
Form.Section = FormSection
Form._meta = SemanticForm._meta
Form.Button = SemanticForm.Button // TBD: not sure what form button does differently than our own Button
Form.Checkbox = SemanticForm.Checkbox
Form.Dropdown = SemanticForm.Dropdown
Form.Field = SemanticForm.Field
Form.Group = SemanticForm.Group
Form.Input = SemanticForm.Input
Form.Radio = SemanticForm.Radio
Form.Select = SemanticForm.Select
Form.TextArea = SemanticForm.TextArea

export default Form
